import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
    user: any | null; // Replace 'any' with your User type
    token: string | null;
    deviceToken: string | null;
    isAuthenticated: boolean;
}

const initialState: AuthState = {
    user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') as string) : null,
    token: localStorage.getItem('token'),
    deviceToken: localStorage.getItem('deviceToken'),
    isAuthenticated: !!localStorage.getItem('token'),
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (
            state,
            action: PayloadAction<{ user: any; token: string; deviceToken?: string }>
        ) => {
            const { user, token, deviceToken } = action.payload;
            state.user = user;
            state.token = token;
            state.deviceToken = deviceToken || state.deviceToken;
            state.isAuthenticated = true;

            // Optionally save to localStorage
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(user));
            if (deviceToken) {
                localStorage.setItem('deviceToken', deviceToken);
            }
        },
        setDeviceToken: (state, action: PayloadAction<string>) => {
            state.deviceToken = action.payload;
            localStorage.setItem('deviceToken', action.payload);
        },
        logout: (state) => {
            state.user = null;
            state.token = null;
            state.deviceToken = null;
            state.isAuthenticated = false;

            // Optionally clear localStorage
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('deviceToken');
        },
    },
});

export const { setCredentials, setDeviceToken, logout } = authSlice.actions;

export default authSlice.reducer;
